import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useApi } from '../api/useApi';
import { ApiClient } from '../api/ApiClient';

export function useResource<T>(
  key: ReadonlyArray<unknown>,
  fetcher: (api: ApiClient) => Promise<T>,
  enabled = true,
): UseQueryResult<T, Error> {
  const api = useApi();
  return useQuery<T, Error>({
    queryKey: key,
    queryFn: () => fetcher(api),
    enabled,
  });
}
